/**
 * The one-line orientation an internal template needs that an email one does not.
 *
 * Two things trip people up: Slack's formatting is not the editor's (asterisks, not bold buttons),
 * and some {tokens} hold a block the board composes from live calendars — a timed agenda with
 * per-person "would have to move X" notes cannot be typed out, so deleting the token loses the
 * agenda rather than inlining it.
 */
export function SlackFormattingHint() {
  return (
    <p className="text-[11px] text-gray-400">
      Slack formatting: *bold*, _italic_, `code` — not the editor&rsquo;s. Tokens in braces are
      filled in by the board; the ones holding a composed block (slots, options, agenda) cannot be
      written by hand, so keep them where you want the block to appear.
    </p>
  );
}
